import * as angular from 'angular';
import imagesRouter from './images.router';
import imagesService from './images.service.js';
import imagesHttpService from './imagesHttp.service.js';
import merchantCategoriesService from 'app/merchants/merchant-categories.service';

/** @constant {angular.module} */
const imagesModule = angular
  .module('ec.opsCenter.images', [])
  .config(imagesRouter)
  .service('imagesService', imagesService)
  .service('imagesHttpService', imagesHttpService)
  .service('merchantCategoriesService', merchantCategoriesService).name;

export default imagesModule;



// WEBPACK FOOTER //
// ./src/app/images/images.module.ts